import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useDialog } from '../../../../../../hooks/use-dialog';
import { RenewContractDialog } from './RenewContractDialog/RenewContractDialog';
import { CalendarTasks } from '@vy/ui-design-system';

type MenuItemRenewOptionsProps = {
  contractId: string;
  isAutoRenewal: boolean;
};

export const MenuItemRenewOptions: React.FC<MenuItemRenewOptionsProps> = ({ contractId, isAutoRenewal }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <MenuItem onClick={handleOpen}>
        <ListItemIcon>
          <CalendarTasks />
        </ListItemIcon>
        <ListItemText>Renewal options</ListItemText>
      </MenuItem>

      <RenewContractDialog
        isOpen={isDialogOpen}
        handleClose={handleClose}
        contractId={contractId}
        isAutoRenewal={isAutoRenewal}
      />
    </>
  );
};
